import { render } from "./Wartung.vue?vue&type=template&id=2c90fd9f"
import script from "./Wartung.vue?vue&type=script&lang=js"
export * from "./Wartung.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__